var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cur",attrs:{"id":"app"}},[_c('div',{attrs:{"id":"mainContainer"}},[_c('keep-alive',{attrs:{"include":"settle,success"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }